import { render, staticRenderFns } from "./AddQuestionPage.vue?vue&type=template&id=bd04447e&"
import script from "./AddQuestionPage.vue?vue&type=script&lang=js&"
export * from "./AddQuestionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports